import { User } from '../types';
import { supabase } from '@/integrations/supabase/client';

export async function performProfileUpdate(values: Record<string, any>) {
  console.log('Updating user profile with values:', values);
  
  // Get current auth session to get token for edge function call
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session) {
    throw new Error('No active session found');
  }
  
  const token = session.access_token;
  
  // Call the update-profile edge function
  const response = await fetch(`${window.location.origin}/api/update-profile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      name: values.name,
      profileImage: values.profileImage
    })
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to update profile');
  }
  
  const result = await response.json();
  
  if (result.success) {
    // Update local user state
    const currentUser = await new Promise<User | null>((resolve) => {
      resolve(session.user as User); // Use the current session user as base
    });
    
    if (currentUser) {
      // Create updated user with the new values
      const updatedUser: User = { 
        ...currentUser, 
        name: values.name || currentUser.name,
        profileImage: values.profileImage || currentUser.profileImage
      };
      
      console.log('User profile updated successfully:', updatedUser);
      return { updatedUser, result };
    }
  } else {
    throw new Error(result.message || 'Profile update failed');
  }
  
  return { result };
}